// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"cr_a bhi_a bhi_w","Messages__hasSeen":"cr_b bhi_p"};